module.exports = __webpack_public_path__ + "static/media/bicycle-fill.a2581a84.svg";